import { LOAN_ROLE_ASSIGNMENT_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const loanRoleAssignmentCriteriaSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_ROLE_ASSIGNMENT_CRITERIA_ACTION_TYPE.GET_LOAN_ROLE_ASSIGNMENT_CRITERIA_SCHEMA:
      return payload || state;

    default:
      return state;
  }
};

export default loanRoleAssignmentCriteriaSchemaReducer;
